import React, {Component} from "react"
import {connect} from 'react-redux';

import Layout from "../../../components/Layout"
import TabsNav from "../../../components/TabsNav"
import data from "../../../data"

import {
    FileUploaderDropContainer,
    DataTable,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    Table,
    TableCell,
    InlineLoading,
} from "carbon-components-react"
import "./index.scss"

import {
    files_action_count,
    files_action_start_upload_files,
    files_action_retry_file,
    files_action_remove_file
} from '../../../store/actions/files';


const rows = [
    {},
];
const headers = [
    {key: "status", header: "Status"},
    {key: "file", header: "File"},
];


class Upload extends Component {
    uuid = 0;
   constructor(props) {
       super(props);
       this.state = {
           oldFiles: [],
       };
   }

    componentDidMount() {
        this.uuid = this.props.uploadingFiles.length;
    }

    incremmentId = () => this.uuid++;

    onChange = e => {
        const {files} = e.target;
        this.setUploadingFiles(files);
    };

    setUploadingFiles = (evt, {addedFiles}) => {

        const {uploadingFiles: oldFiles} = this.props;
        //const OLDFILES = this.state.oldFiles;
        const newFiles = addedFiles.map(file => ({
            uuid: Math.random(0, 100),
            name: file.name,
            size: file.size,
            status: "uploading",
            iconDescription: "Uploading",
            file: file,
            progress: 0,
            estimatedTime: 0, // seconds
            startAt: false,
            error: false
        })).filter(f => this.state.oldFiles.indexOf(f.name) < 0);
        //console.log('NEW', newFiles);
       //console.log('OLD', this.state.oldFiles);
        let oldF = addedFiles.map(f => f.name);
        this.setState(state => {
            const oldFiles = state.oldFiles.concat(oldF);
            return {
                oldFiles,
            };
        });


        this.props.startUploadFiles([...newFiles]);
    };


    removeFileFromList = thisFile => e => {
        e.preventDefault();
        this.props.removeFile(thisFile);
    };

    render() {

        const {uploadingFiles} = this.props;

        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p></p>
                        <h1>{data.sideBar.dataset.links[0]}</h1>
                        <br/>
                    </div>
                </div>
                <div className="section-light">
                    <div className="section-light-heading">
                        <p>
                            <strong>{data.captura.manual.title}</strong>
                        </p>
                        <br/>
                        <p className="muted">{data.captura.manual.subtitle}</p>
                        <br/>
                        <br/>
                        <div className="file-upload-container">
                            <FileUploaderDropContainer
                                className="file-upload"
                                labelText={getLabel()}
                                onAddFiles={this.setUploadingFiles}
                                multiple
                            />
                            <br/>
                            <br/>
                            <div>
                                <DataTable rows={rows} headers={headers}>
                                    {({
                                          rows,
                                          headers,
                                          getHeaderProps,
                                          getRowProps,
                                          getTableProps,
                                          onInputChange,
                                      }) => (
                                        <TableContainer title={data.captura.processando.table_title}
                                                        description={uploadingFiles.length + " files"}
                                                        className="upload-table">
                                            <TableToolbar>
                                                <TableToolbarContent>
                                                </TableToolbarContent>
                                            </TableToolbar>
                                            <Table {...getTableProps()}>
                                                <TableHead>
                                                    <TableRow>
                                                        {headers.map((header) => (
                                                            <TableHeader
                                                                key={header.key}
                                                                {...getHeaderProps({header})}
                                                            >
                                                                {header.header}
                                                            </TableHeader>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {uploadingFiles.map(item => (
                                                        <TableRow
                                                            className="upload-row"
                                                            key={item.id}
                                                        >
                                                            <TableCell key={item.id}>
                                                                {item.progress < 100 ?
                                                                    <InlineLoading
                                                                        status="active"
                                                                        iconDescription="Progress"
                                                                        description="Progress..."
                                                                    />
                                                                    : <InlineLoading
                                                                        status="finished"
                                                                        iconDescription="Done"
                                                                        description="Done"
                                                                    />}
                                                            </TableCell>
                                                            <TableCell key={item.name}>
                                                                {item.name}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    )}
                                </DataTable>
                            </div>

                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

const getLabel = () => (
    <div className="file-upload">
        <p>{data.captura.manual.uploadLabel}</p>
    </div>
);


const mapStateToProps = ({files}) => files;

const mapDispatchToProps = dispatch => ({
    countFiles: () => dispatch(files_action_count()),
    startUploadFiles: files => dispatch(files_action_start_upload_files(files)),
    retryFile: file => dispatch(files_action_retry_file(file)),
    removeFile: file => dispatch(files_action_remove_file(file))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Upload);
